import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { PdfViewer } from "./PdfViewer";
import {
  type PdfViewerDataProps,
  pdfViewerDataSchema,
} from "./PdfViewer.schema";
import { PDF_VIEWER_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [PDF_VIEWER_TAG_NAME]: {
      props: PdfViewerDataProps;
      handle: never;
    };
  }
}

export function RWCPdfViewer({
  tools,
  ...props
}: PdfViewerDataProps): JSX.Element {
  return <PdfViewer {...props} toolbar={tools?.length !== 0} tools={tools} />;
}

componentManager.register(
  rwc(PDF_VIEWER_TAG_NAME, {
    component: RWCPdfViewer,
    dataSchema: pdfViewerDataSchema,
  }),
);
